module.exports = __webpack_public_path__ + "img/play-mind.b6a942d6.svg";